<template>
  <component :is="currentComponent" :course="course" v-on="$listeners" v-bind="$attrs"></component>
</template>

<script>
import { mapGetters } from 'vuex';
import { COURSE_TYPE_DICT } from '@/core/dict/course-dict';
import RailwayCompanySettlementDrawer from './railway-company-settlement-drawer';
import TransportCompanySettlementDrawer from './transport-company-settlement-drawer';
import ServiceCompanySettlementDrawer from './service-company-settlement-drawer';
import ServiceTransportCompanySettlementDrawer from './service-transport-company-settlement-drawer';
import ContractorSettlementDrawer from './contractor-settlement-drawer';
import SubcontractorSettlementDrawer from './subcontractor-settlement-drawer';

export default {
  name: 'SettlementDrawerFactory',
  inheritAttrs: false,
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['isCompany', 'isTransportCompany', 'user']),
    isServiceCourse() {
      return this.course['@type'] === COURSE_TYPE_DICT.SERVICE_COURSE;
    },
    currentComponent() {
      if (this.isCompany) {
        if (this.isServiceCourse) {
          return ServiceCompanySettlementDrawer;
        }
        return RailwayCompanySettlementDrawer;
      }

      if (this.isTransportCompany) {
        if (this.course.subcontractor === null) {
          if (this.isServiceCourse) {
            return ServiceTransportCompanySettlementDrawer;
          }
          return TransportCompanySettlementDrawer;
        }

        if (this.course.contractor.id === this.user.company.id) {
          return ContractorSettlementDrawer;
        }

        return SubcontractorSettlementDrawer;
      }

      return null;
    },
  },
};
</script>

<style lang="scss" scoped></style>
